<template>
  <div>
    <Menu
      class="app-menu"
      rounded="0"
      :tabindex="tabindex"
      :close-on-click="true"
      :close-on-content-click="false"
      :max-height="300"
      :min-width="'25rem'"
      :attach="'#agents_filter_menu_list'"
    >
      <template v-slot:menu-btn="{ on, attrs }">
        <v-toolbar-title v-on="on" class="app-menu-btn filter-agents-btn filter--btn">
          <FIcon :name="'head-set'" size="1.8rem" class="agent-icon" />
          <span class="btn-title"> {{ agentName }} </span>
          <span class="count-badge">{{ orderListCount }}</span>
          <span class="menu-arrow" :class="attrs['aria-expanded'] !== 'false' ? 'app-menu-active' : ''"></span>
        </v-toolbar-title>
      </template>
      <template #menu-list>
        <div class="menu-list-container">
          <v-progress-circular class="order-agent-list-loader" :value="20" indeterminate v-if="isLoading" />
          <v-list class="agents-list">
            <div class="menu-search-section">
              <v-list-item>
                <v-list-item-title>
                  <label for="agents_search_input" class="search-input-container">
                    <input
                      type="text"
                      id="agents_search_input"
                      class="search-input"
                      v-model.trim="query"
                      autocomplete="off"
                      :placeholder="$t('agents_search_placeholder')"
                    />
                    <FIcon
                      name="close"
                      color="#06c1ed"
                      size="1rem"
                      v-if="!!query"
                      @click.native="handleOnResetSearch"
                    />
                  </label>
                </v-list-item-title>
              </v-list-item>

              <div class="divider" />
            </div>
            <!--            <div v-if="!isAgents">-->
            <!--              <v-list-item-title class="px-4 py-2 no-agents">-->
            <!--                {{ $t("no_agents") }}-->
            <!--              </v-list-item-title>-->
            <!--            </div>-->

            <v-radio-group v-model="selected" :hide-details="true" class="filter-agents">
              <v-list-item :hide-details="true">
                <v-list-item-title>
                  <v-radio
                    class="filter-checkbox"
                    :ripple="false"
                    :hide-details="true"
                    :label="$t('all_orders')"
                    :value="'all'"
                    @click="(e) => handleIsAllOrders(e)"
                  />
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-for="(agent, index) in list" :key="`agent-filter-id-${index}`" :hide-details="true">
                <v-list-item-title>
                  <v-radio
                    class="filter-checkbox"
                    :ripple="false"
                    :hide-details="true"
                    :label="agent.getFullName()"
                    v-model="agent.id"
                    @click="(e) => handleOnSelect(e, agent.id)"
                  />
                </v-list-item-title>
              </v-list-item>
            </v-radio-group>
          </v-list>
        </div>
      </template>
    </Menu>
    <div class="agents-filter-menu-list" id="agents_filter_menu_list"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { StorageConstants } from "@/enums/storage.enum";
import Storage from "@/services/storage";

export default {
  name: "AgentsList",

  data() {
    return {
      isLoading: true,
      toggleAllFilters: true,
      selected: null,
      query: "",
      list: [],
      original: [],
      currentUser: null,
      isAllOrders: false,
    };
  },

  props: {
    tabindex: {
      type: String,
      default: "1",
    },

    total: {
      type: Number | String,
      default: 0,
    },
  },

  beforeMount() {
    this.getBusinessAgents();
  },

  computed: {
    ...mapGetters({
      filter: "App/filter",
      agentsList: "Business/agents",
      orderListCount: "Orders/OrderListCount",
    }),

    agentName() {
      if (this.selected === "all") return this.$t("all_orders");

      const selected = this.list?.find((i) => i.id === this.selected);
      return selected?.getFullName() || this.$t("select_agent");
    },

    agents() {
      return this.agentsList;
    },

    isAgents() {
      return this.list.length !== 0;
    },
  },

  watch: {
    query: {
      immediate: true,
      handler(value) {
        let list = window._.clone(this.agentsList);

        const selected = window._.clone(this.selected);

        if (!!value) {
          //search on list
          this.list = list.filter((item) => item?.getFullName()?.toLowerCase()?.includes(value.toLowerCase()));
        } else {
          this.list = list;
        }

        this.$nextTick(() => {
          // reset selected
          this.selected = selected;
        });
      },
    },
  },

  methods: {
    ...mapActions({
      getAgents: "Business/getAgents",
    }),

    /**
     * Get business Agents
     * @return {void}
     */
    async getBusinessAgents() {
      const session = Storage.get(StorageConstants.SESSION);

      await this.getAgents();

      await this.$nextTick(async () => {
        this.list = this.agentsList;
        this.original = window._.clone(this.agentsList);
        this.isLoading = false;
      });

      const index = this.list.findIndex((l) => l.email === session.email);

      this.selected = this.list?.[index]?.id;
      this.handleOnSelect(null, this.selected);
    },

    /**
     * Handle to reset search
     * @return {void}
     */
    handleOnResetSearch() {
      this.query = "";
    },

    /**
     * Handle on select agent
     * @param e
     * @param agent
     */
    handleOnSelect(e, agent) {
      if (e) {
        e?.preventDefault();
        e?.stopPropagation();
      }

      this.$nextTick(() => {
        this.selected = agent;
        this.filter.agent = agent;
      });
    },

    /**
     * Handle on select agent
     * @param e
     */
    handleIsAllOrders(e) {
      e.preventDefault();
      e.stopPropagation();

      this.$nextTick(() => {
        this.selected = "all";
        this.filter.agent = "all";
      });
    },
  },
};
</script>
<style src="./styles.scss" scoped lang="scss" />
